module.exports = __webpack_public_path__ + "img/icon3.d50cd024.png";